import { render, staticRenderFns } from "./adminCount.vue?vue&type=template&id=78bac4b4&scoped=true&"
import script from "./adminCount.vue?vue&type=script&lang=js&"
export * from "./adminCount.vue?vue&type=script&lang=js&"
import style0 from "./adminCount.vue?vue&type=style&index=0&id=78bac4b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bac4b4",
  null
  
)

export default component.exports